import React from "react"
import PrimaryHeadingTextGallery from "../Mainmoduls/PrimaryHeadingTextGallery"
import PrimaryLeftImageRightHeadingTextButton from "../Mainmoduls/PrimaryLeftImageRightHeadingTextButton"
import PrimaryGalleryLeftImageRightHeadingText from "../Mainmoduls/PrimaryGalleryLeftImageRightHeadingText"
import PrimaryIconCollection from "../Mainmoduls/PrimaryIconCollection"
import PrimaryImage from "../Mainmoduls/PrimaryImage"
import PrimaryHeadingTextImages from "../Mainmoduls/PrimaryHeadingTextImages"
import SecondaryLinkTiles from "../Mainmoduls/SecondaryLinkTiles"
import SecondaryHistory from "../Mainmoduls/SecondaryHistory"
import WorkshopQuoteImageText from "../Mainmoduls/WorkshopQuoteImageText"
import WorkshopListImages from "../Mainmoduls/WorkshopListImages"
import WorkshopTextImageButton from "../Mainmoduls/WorkshopTextImageButton"
import WorkshopShiftedTextButton from "../Mainmoduls/WorkshopShiftedTextButton"
import WorkshopHeadingText from "../Mainmoduls/WorkshopHeadingText"
import ContactFaq from "../Mainmoduls/ContactFaq"
import WorkshopGalleryBig from "../Mainmoduls/WorkshopGalleryBig"
import WorkshopGallerySmall from "../Mainmoduls/WorkshopGallerySmall"
import ContactPerson from "../Mainmoduls/ContactPerson"
import ContactPersonCards from "../Mainmoduls/ContactPersonCards"
import SecondaryLeftImageRightTextImage from "../Mainmoduls/SecondaryLeftImageRightTextImage"
import SecondaryCenteredText from "../Mainmoduls/SecondaryCenteredText"
import ContactForm from "../Mainmoduls/ContactForm"
import CalendarComponent from "../Mainmoduls/Calendar"
import ZigZag from "../Mainmoduls/ZigZag"
import Quote from "../Mainmoduls/Quote"
import SecondaryLeftTextRightImageButton from "../Mainmoduls/SecondaryLeftTextRightImageButton"
import SecondaryHeadingSplitTextImage from "../Mainmoduls/SecondaryHeadingSplitTextImage"
import SecondaryWheelservice from "../Mainmoduls/SecondaryWheelservice"
import SecondaryHeadingTextTiles from "../Mainmoduls/SecondaryHeadingTextTiles"
import ArticlesPreview from "../Mainmoduls/ArticlesPreview"
import Articles from "../Mainmoduls/Articles"
import ImagesSideBySide from "../Mainmoduls/ImagesSideBySide"


type MainModulType = {
    modulName: string
    modulSettingColor: string
    modulSettingSpacing: string
    modulVariants: any[] // Hier Typen weiter definieren
}

export default function MainModul(props: MainModulType) {
    const modulRegistry: { [key: string]: React.ComponentType<any> } = {
        primaryHeadingTextGallery: PrimaryHeadingTextGallery,
        primaryLeftImageRightHeadingTextButton: PrimaryLeftImageRightHeadingTextButton,
        primaryGalleryLeftImageRightHeadingText: PrimaryGalleryLeftImageRightHeadingText,
        primaryIconCollection: PrimaryIconCollection,
        primaryImage: PrimaryImage,
        primaryHeadingTextImages: PrimaryHeadingTextImages,
        secondaryLeftImageRightTextImage:SecondaryLeftImageRightTextImage,
        secondaryCenteredText:SecondaryCenteredText,
        secondaryLinkTiles: SecondaryLinkTiles,
        secondaryHistory: SecondaryHistory,
        secondaryLeftTextRightImageButton: SecondaryLeftTextRightImageButton,
        secondaryHeadingSplitTextImage:SecondaryHeadingSplitTextImage,
        secondaryWheelservice: SecondaryWheelservice,
        secondaryHeadingTextTiles: SecondaryHeadingTextTiles,
        workshopQuoteImageText: WorkshopQuoteImageText,
        workshopListImages: WorkshopListImages,
        workshopTextImageButton: WorkshopTextImageButton,
        workshopShiftedTextButton: WorkshopShiftedTextButton,
        workshopHeadingText: WorkshopHeadingText,
        contactFaq: ContactFaq,
        contactPerson: ContactPerson,
        contactForm: ContactForm,
        workshopGalleryBig: WorkshopGalleryBig,
        workshopGallerySmall: WorkshopGallerySmall,
        calender: CalendarComponent,
        zigZag: ZigZag,
        quote: Quote,
        articlesPreview: ArticlesPreview,
        articles: Articles,
        imagesSideBySide: ImagesSideBySide,
        contactPersonCards: ContactPersonCards
    }

    return (
        <section>
            {/* <h2>{props?.modulName}</h2> */}
            {(props?.modulVariants ?? []).map((block, index) => {
                const ModulComponent = modulRegistry[block?.type]
                if (!ModulComponent) {
                    return (
                        <div key={index}>
                            Kein Modul für Typ: <strong>{block?.type}</strong>
                        </div>
                    )
                }
                return (
                    // <div key={index} className={`${getShade(props?.modulSettingColor)} ${getSpacing(props?.modulSettingSpacing)}`}>
                    <div key={index}>
                        <ModulComponent key={index} {...block} />
                    </div>
                )
            })}
        </section>
    )
}
